export const apiErrorMessages = {
  noSeatsRemainingError:
    "You don't have enough remaining seats to create this number of memberships",
  partnerIdError: 'A partner with that partner id already exists!',
  sectionNameLengthError: 'Length must be between 3 and 64.',
  existingEmailError: 'A membership already exists for this email',
  invalidEmailError: 'Not a valid email address.',
  userAlreadyPaidError: 'The user has already bought this course',
};
